import api, {
    deleteFn,
    getFn,
    IdApiArg,
    insertFn,
    PaginatedResult,
    prepareFTX,
    SortColumn,
    UpdateArg, updateFn,
    UpdateResp
} from "../../api";
import {Tables, TablesInsert, TablesUpdate} from "../../apitypes";
import {supabase} from "../../supabase";

export interface PartnerFilter {
    active?: boolean,
    filter?: string,
    page: number,
    pageSize: number,
    sort?: SortColumn[],
}

export const peopleApi = api.injectEndpoints({
    endpoints: (build) => ({
        // Machine types
        getPartner: build.query<PaginatedResult<Tables<"partner">>, PartnerFilter>({
            queryFn: async (args) => {
                let q = supabase
                    .from("partner")
                    .select("*", {count: "estimated"})

                if (args.filter) {
                    q = q.textSearch("partner_ftx", prepareFTX(args.filter))
                }
                if (args.active === true || args.active === false) {
                    q = q.eq("Active", args.active)
                }
                if (args.sort) {
                    args.sort.forEach(s => {
                        q = q.order(s.col, {ascending: s.dir == "asc"})
                    })
                }
                const {data, count, error} = await q.range(args.pageSize * args.page, args.pageSize * (args.page + 1));

                if (error) return {error};
                return {data:{result:data, count}}
            },
            providesTags: ["Partner"]
        }),
        getPartnerById: build.query<Tables<"partner"> | null, IdApiArg>({
            query: getFn("partner"),
            providesTags: ["Partner"]
        }),
        postPartner: build.mutation<UpdateResp, TablesInsert<"partner">>({
            query: insertFn("partner"),
            invalidatesTags: ["Partner"],
        }),
        deletePartnerById: build.mutation<UpdateResp, IdApiArg>({
            query: deleteFn("partner"),
            invalidatesTags: ["Partner"],
        }),
        putPartnerById: build.mutation<UpdateResp, UpdateArg<"partner">>({
            query: updateFn("partner"),
            invalidatesTags: ["Partner"],
        }),
    })
});


export type PartnerApiPut = TablesUpdate<"partner">

export type PartnerApiGet = Tables<"partner">


export const {

    useGetPartnerQuery,
    useGetPartnerByIdQuery,
    usePostPartnerMutation,
    usePutPartnerByIdMutation,
    useDeletePartnerByIdMutation,

} = peopleApi;
